import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgCelebrate = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M12.287.036c.64.16 1.027.807.868 1.445l-.636 2.544a1.192 1.192 0 0 1-2.313-.579l.636-2.543a1.192 1.192 0 0 1 1.445-.867ZM3.624 1.264a1.192 1.192 0 0 1 1.6.528l1.146 2.27a1.192 1.192 0 1 1-2.128 1.074l-1.146-2.27a1.192 1.192 0 0 1 .528-1.602ZM19.793 2.52a1.192 1.192 0 0 0 1.686 1.686l1.798-1.798A1.192 1.192 0 0 0 21.59.722L19.793 2.52Zm-2.501 4.187c.465.466.465 1.22 0 1.686L16.02 9.664a1.192 1.192 0 1 1-1.686-1.685l1.272-1.272a1.192 1.192 0 0 1 1.686 0Zm5.803 6.45a1.192 1.192 0 0 0-.578-2.313l-2.543.636a1.192 1.192 0 1 0 .578 2.313l2.544-.636Zm-4.748 4.975a1.192 1.192 0 0 1 1.607-.51l2.258 1.17a1.192 1.192 0 0 1-1.096 2.117l-2.258-1.17a1.192 1.192 0 0 1-.51-1.607ZM7.732 7.98a1.192 1.192 0 0 0-1.926.346L.223 20.508a2.467 2.467 0 0 0 3.27 3.27l12.18-5.584a1.19 1.19 0 0 0 .696-1.083v-.002c0-.316-.125-.619-.349-.843L7.732 7.98Zm-5.34 13.519 4.867-10.621 5.864 5.864-10.621 4.867a.084.084 0 0 1-.117-.06.084.084 0 0 1 .007-.05Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgCelebrate);
export default ForwardRef;
